import classNames from "classnames";

import styles from "./CanvasEmbed.module.css";
import { Button } from "@zapier/design-system-beta";
import { Icon } from "@zapier/design-system";
import { isProduction } from "src/utils/environment";

type CanvasEmbedProps = {
  className?: string;
  url: string;
  showOpenInCanvasButton?: boolean;
};

export function CanvasEmbed({
  url,
  className,
  showOpenInCanvasButton = true,
}: CanvasEmbedProps) {
  const onOpenClick = () => {
    window.open(url, "_blank");
  };

  return (
    <div className={classNames(styles.root, className)}>
      {showOpenInCanvasButton && (
        <div className={styles.controls}>
          <Button
            variant="tertiary"
            iconStart={<Icon name="arrowOffsite" />}
            onPress={onOpenClick}
          >
            Open in Canvas
          </Button>
        </div>
      )}

      <iframe
        aria-label="Canvas preview iframe"
        title="Canvas preview iframe"
        // Make URL relative for dev so we can see the Canvas preview before prod
        src={isProduction ? url : url.replace(/^https?:\/\/[^/]+/, "")}
        className={styles.frame}
      />
    </div>
  );
}
